export default {
      id: "oc-res-pricecomparator-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-pricecomparator",
      toString: function () {
        return this.url;
      }
    }